import { Api } from "services/api/api.service";
import { ScheduleDispatch } from "./scheduleStore";
import { ScheduleState } from "./scheduleStore.reducer";
import { ScheduleShiftItem } from "web-apps/company/components/schedule/types/schedule.types";
import { ScheduleSortBy } from "services/api/company/schedule.service";

let requestCounter = 0;

const getSchedule =
  (dispatch: ScheduleDispatch, _state: ScheduleState) =>
  async (
    companyId: number,
    fromDate: string,
    toDate: string,
    page: number,
    pageSize: number,
    sortBy?: ScheduleSortBy,
    workGroupIds?: number[],
    workerIds?: number[],
  ) => {
    const requestId = (requestCounter += 1);
    dispatch({ type: "SET_ACTIVE_REQUEST_ID", payload: requestId });
    dispatch({
      type: "SET_IS_LOADING",
      payload: { value: page === 0, requestId },
    });
    dispatch({
      type: "SET_IS_LOADING_MORE",
      payload: { value: page > 0, requestId },
    });
    dispatch({ type: "SET_REQUEST_ERROR", payload: null });

    await Api()
      .company.schedule.getSchedule(
        companyId,
        fromDate,
        toDate,
        page,
        pageSize,
        sortBy,
        workGroupIds,
        workerIds,
      )
      .then((res) => {
        dispatch({
          type: "SET_SCHEDULE",
          payload: {
            data: res.data,
            requestId,
            append: page > 0,
            page,
            pageSize,
          },
        });
      })
      .catch((err: Error) => {
        console.error("Error fetching schedule", err);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err },
        });
      });

    dispatch({ type: "SET_IS_LOADING", payload: { value: false, requestId } });
    dispatch({
      type: "SET_IS_LOADING_MORE",
      payload: { value: false, requestId },
    });
  };

export const scheduleActions = (
  dispatch: ScheduleDispatch,
  state: ScheduleState,
) => ({
  getSchedule: getSchedule(dispatch, state),
  resetSchedule: () => dispatch({ type: "RESET_SCHEDULE" }),
  updateShift: (gigShiftId: number, patch: Partial<ScheduleShiftItem>) =>
    dispatch({ type: "UPDATE_SHIFT", payload: { gigShiftId, patch } }),
});
